import i18n from '../i18n'

export const ERROR_CODES = {
  2003: {
    en: 'The building id/product number does not exist.',
    'zh-tw': 'Building ID/產品編號不存在。'
  },
  4999: {
    en: 'Input Validation Failed',
    'zh-tw': '欄位輸入錯誤。'
  },
  5000: {
    en: 'object Id given is invalid',
    'zh-tw': '提供的物件 ID 無效。'
  },
  9014: {
    en: 'Target user not found',
    'zh-tw': '找不到目標用戶。'
  },
  10001: {
    en: 'API parameters is wrong',
    'zh-tw': 'API 參數錯誤。'
  },
  80101: {
    en: 'Booking end time cannot be earlier than start time',
    'zh-tw': '預訂結束時間不能早於開始時間。'
  }
}

const lang = i18n.locale

export const getLocalizedErrorMessage = (errorCode) => {
  return ERROR_CODES[errorCode]?.[lang] || '未知錯誤，請聯繫支援。'
}
